import api from './axiosInstance';

export const userApi = {
  search: (params = {}) => api.get('/admin/users/search', {params}),
  getById: id => api.get(`/admin/users/${id}`),
  create: data => api.post('/admin/users', data),
  update: (id, data) => api.put(`/admin/users/${id}`, data),
  delete: id => api.delete(`/admin/users/${id}`),
  reactivate: id => api.put(`/admin/users/${id}/reactivate`),
};
